import * as React from 'react';
import { DialogTitle } from '@material-ui/core';
import { DialogContent } from '@material-ui/core';
import { DialogActions } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { observer } from 'mobx-react';
import { IObservableObject, IObservableValue, observable } from 'mobx';
import { EmployeeDto } from './userTypes';
import { isValidationErrors, ValidationErrors } from '../../api/restApi';
import { EmployeeForm } from './EmployeeForm';
import { translation } from '../../i18n';
import { Dialog } from '@material-ui/core';
import { Spinner } from '../../spinner/Spinner';
import { isValid } from '../../util/validations';
import { updateEmployee } from './userApi';

interface Props {
  onClose: () => void;
  onSave: () => void;
  open: boolean;
  user: EmployeeDto & IObservableObject;
}

@observer
export default class EditEmployeeDialog extends React.Component<Props> {

  @observable private validationErrors: ValidationErrors | undefined = undefined;
  private dirtyState: IObservableValue<boolean> = observable.box(false);
  private loading: IObservableValue<boolean> = observable.box(false);

  constructor(props: Props) {
    super(props);
    this.init = this.init.bind(this);
  }

  public render() {
    return (
      <Dialog
        id="editEmployeeDialog"
        open={this.props.open}
        onClose={this.props.onClose}
        fullWidth={true}
        maxWidth="md"
        onRendered={this.init}
      >
        <DialogTitle id="form-dialog-title">{translation.t('editEmployeeDialog.title')}</DialogTitle>
        {
          this.loading.get() ?
            <Spinner/> :
            <>
              <DialogContent>
                <EmployeeForm
                  existingEmployee={this.props.user}
                  employee={this.props.user}
                  dirtyState={this.dirtyState}
                  fieldErrors={this.validationErrors ? this.validationErrors.fieldErrors : []}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={this.props.onClose} color="primary">
                  {translation.t('actions.cancel')}
                </Button>
                <Button onClick={() => this.onSaveClicked()} color="primary">
                  {translation.t('actions.save')}
                </Button>
              </DialogActions>
            </>
        }
      </Dialog>)
  }

  private init() {
    this.dirtyState.set(false);
    this.validationErrors = undefined;
  }

  private onSaveClicked() {
    this.validationErrors = isValid(this.props.user);
    if (this.validationErrors === undefined || this.validationErrors.fieldErrors.length === 0) {
      this.loading.set(true);
      updateEmployee(this.props.user).then(
        data => {
          this.loading.set(false);
          if (isValidationErrors(data)) {
            this.validationErrors = data;
          } else {
            this.validationErrors = undefined;
            this.props.onSave()
          }
        }
      );
    }
  }
}
